import React, { ReactNode } from 'react';

import {
  DrawerBackdrop,
  DrawerBody,
  DrawerCloseTrigger,
  DrawerContent,
  DrawerHeader,
  DrawerRoot,
  DrawerTitle,
} from '../ui/drawer';

type DrawerRootProps = React.ComponentProps<typeof DrawerRoot>;

export type DrawerProps = {
  open: boolean;
  placement?: DrawerRootProps['placement'];
  onOpenChange?: DrawerRootProps['onOpenChange'];
  title: ReactNode;
  body: ReactNode;
};

export const Drawer = (props: DrawerProps) => {
  return (
    <DrawerRoot
      open={props.open}
      placement={props.placement}
      onOpenChange={props.onOpenChange}
    >
      <DrawerBackdrop />
      <DrawerContent>
        <DrawerCloseTrigger />
        <DrawerHeader>
          <DrawerTitle>{props.title}</DrawerTitle>
        </DrawerHeader>
        <DrawerBody>{props.body}</DrawerBody>
      </DrawerContent>
    </DrawerRoot>
  );
};
